/* =========================================================================
   KIMPOPS — shop page interactions (commerce pages)
   Reveal-on-scroll, sticky-nav state, accordions, PDP gallery + qty +
   flavor switcher + live price, collection filters, fake forms.
   Cart logic lives in cart.js. index.html is untouched.
   ========================================================================= */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var K = window.KIMPOPS || {};

  /* ---------- reveal-on-scroll (reuses styles.css [data-reveal]) ---------- */
  var reveals = document.querySelectorAll("[data-reveal]");
  if ("IntersectionObserver" in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: "0px 0px -8% 0px" });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add("is-in"); });
  }

  /* ---------- nav: sticky island on scroll (prototype-v2 behaviour) ----------
     At the very top the nav is transparent so it blends into the beige header with NO
     shadow (looks like part of the top header); once you scroll it "sticks" into the
     cream island with its shadow. */
  var nav = document.querySelector(".nav");
  function onScroll() { if (nav) nav.classList.toggle("is-stuck", window.scrollY > 8); }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---------- flame buttons: play the Lottie once on hover (matches homepage) ---------- */
  document.querySelectorAll(".flame").forEach(function (flame) {
    var btn = flame.closest("a, button");
    if (!btn) return;
    btn.addEventListener("mouseenter", function () {
      try { flame.stop(); flame.seek(0); flame.play(); } catch (e) {}
    });
  });

  /* ---------- accordions (PDP details + FAQ) ---------- */
  document.querySelectorAll(".acc__head").forEach(function (head) {
    head.addEventListener("click", function () {
      var acc = head.closest(".acc");
      var openNow = acc.classList.contains("is-open");
      // within one accordion group, close siblings (classic FAQ feel)
      var group = acc.closest(".accordion");
      if (group && !openNow) group.querySelectorAll(".acc.is-open").forEach(function (a) { a.classList.remove("is-open"); });
      acc.classList.toggle("is-open", !openNow);
    });
  });

  /* ---------- collection filter chips ---------- */
  var chips = document.querySelectorAll(".chip[data-filter]");
  if (chips.length) {
    var cards = Array.prototype.slice.call(document.querySelectorAll(".pcard[data-available]"));
    var countEl = document.querySelector("[data-shop-count]");
    function applyFilter(f) {
      var shown = 0;
      cards.forEach(function (c) {
        var avail = c.getAttribute("data-available") === "true";
        var heat = parseInt(c.getAttribute("data-heat"), 10) || 0;
        var ok = f === "all" ||
                 (f === "available" && avail) ||
                 (f === "soon" && !avail) ||
                 (f === "hot" && heat >= 3);
        c.style.display = ok ? "" : "none";
        if (ok) shown++;
      });
      if (countEl) countEl.textContent = shown + (shown === 1 ? " product" : " products");
    }
    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        chips.forEach(function (c) { c.classList.remove("is-active"); });
        chip.classList.add("is-active");
        applyFilter(chip.getAttribute("data-filter"));
      });
    });
  }

  /* ---------- PDP gallery thumbnails ---------- */
  function bindThumbs() {
    var main = document.querySelector("[data-pdp-main]");
    var thumbs = document.querySelector("[data-pdp-thumbs]");
    if (!main || !thumbs) return;
    thumbs.addEventListener("click", function (e) {
      var t = e.target.closest(".pdp__thumb");
      if (!t) return;
      var src = t.getAttribute("data-src");
      if (src) main.src = src;
      thumbs.querySelectorAll(".pdp__thumb").forEach(function (x) { x.classList.remove("is-active"); });
      t.classList.add("is-active");
    });
  }

  /* ---------- PDP qty stepper (standalone selector) ---------- */
  document.querySelectorAll("[data-product] .qty").forEach(function (q) {
    var input = q.querySelector("[data-qty-input]");
    if (!input) return;
    q.addEventListener("click", function (e) {
      if (e.target.closest("[data-qty-dec]")) input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      if (e.target.closest("[data-qty-inc]")) input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  /* ---------- PDP: purchase-option live price ---------- */
  function refreshBuyPrice() {
    var root = document.querySelector("[data-product]");
    if (!root || !K.PRODUCTS) return;
    var p = K.PRODUCTS[root.getAttribute("data-handle")];
    if (!p) return;
    var once = root.querySelector("[data-price-once]");
    var sub = root.querySelector("[data-price-sub]");
    if (once) once.textContent = K.money(p.priceCents);
    if (sub) sub.textContent = K.money(K.unitPrice(p, true));
  }

  /* ---------- PDP flavor switcher (variant-style) ---------- */
  function heatHTML(n) {
    var s = "";
    for (var i = 1; i <= 5; i++) s += '<span' + (i > n ? ' class="off"' : "") + "></span>";
    return s;
  }
  function switchFlavor(handle) {
    var root = document.querySelector("[data-product]");
    if (!root || !K.PRODUCTS || !K.PRODUCTS[handle]) return;
    var p = K.PRODUCTS[handle];
    root.setAttribute("data-handle", handle);

    var set = function (sel, val, attr) {
      var el = root.querySelector(sel);
      if (!el) return;
      if (attr) el.setAttribute(attr, val); else el.textContent = val;
    };
    set("[data-pdp-title]", p.title);
    set("[data-pdp-statement]", p.statement || "");
    set("[data-pdp-blurb]", p.blurb || "");
    set("[data-pdp-crumb]", p.title);
    set("[data-pdp-weight]", p.weight || "");
    var heatEl = root.querySelector("[data-pdp-heat]");
    if (heatEl) heatEl.innerHTML = heatHTML(p.heat) + '<span class="pdp__heatlabel">' + heatLabel(p.heat) + "</span>";
    var main = root.querySelector("[data-pdp-main]");
    if (main) main.src = p.img;
    // thumbnails
    var thumbs = root.querySelector("[data-pdp-thumbs]");
    if (thumbs) {
      thumbs.innerHTML = (p.gallery || [p.img]).map(function (src, i) {
        return '<button class="pdp__thumb' + (i === 0 ? " is-active" : "") + '" data-src="' + src + '"><img src="' + src + '" alt="" /></button>';
      }).join("");
    }
    // price
    var pr = root.querySelector("[data-pdp-price]");
    if (pr) pr.innerHTML = (p.compareCents ? "<s>" + K.money(p.compareCents) + "</s> " : "") + K.money(p.priceCents);

    // availability: swap buy area
    root.classList.toggle("is-soon", !p.available);
    var buyAvail = root.querySelector("[data-buy-available]");
    var buySoon = root.querySelector("[data-buy-soon]");
    if (buyAvail) buyAvail.hidden = !p.available;
    if (buySoon) buySoon.hidden = !!p.available;

    // active pill
    root.querySelectorAll(".flavorpill").forEach(function (pill) {
      pill.classList.toggle("is-active", pill.getAttribute("data-flavor") === handle);
    });
    refreshBuyPrice();
  }
  function heatLabel(n) { return n >= 5 ? "Inferno" : n >= 4 ? "Very hot" : n >= 3 ? "Hot" : n >= 2 ? "Medium" : "Mild"; }

  // pill clicks + deep-link via ?handle=
  var productRoot = document.querySelector("[data-product]");
  if (productRoot) {
    bindThumbs();
    refreshBuyPrice();
    productRoot.addEventListener("change", function (e) {
      if (e.target.matches('input[name="purchase"]')) refreshBuyPrice();
    });
    productRoot.querySelectorAll(".flavorpill").forEach(function (pill) {
      pill.addEventListener("click", function () {
        var h = pill.getAttribute("data-flavor");
        if (h) switchFlavor(h);
      });
    });
    var qp = new URLSearchParams(window.location.search).get("handle");
    if (qp && K.PRODUCTS && K.PRODUCTS[qp]) switchFlavor(qp);
  }

  /* ---------- fake forms (contact, notify, newsletter) ---------- */
  document.querySelectorAll("[data-fake-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var bad = false;
      form.querySelectorAll("[required]").forEach(function (f) {
        var empty = !f.value || (f.type === "email" && f.value.indexOf("@") === -1);
        f.style.borderColor = empty ? "var(--red)" : "";
        if (empty && !bad) { f.focus(); bad = true; }
      });
      if (bad) return;
      var ok = form.querySelector("[data-form-success]") ||
               (form.parentNode && form.parentNode.querySelector("[data-form-success]"));
      form.reset();
      var btn = form.querySelector('button[type="submit"], .btn');
      if (btn) { btn.textContent = "Sent ✓"; }
      if (ok) { ok.classList.add("is-on"); }
    });
  });
})();
